import classNames from 'classnames';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import {
    Highlighter,
    Menu,
    MenuItem,
    Typeahead
} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as style from './IndustryTagSelect.module.less';
import { useClientSettingStore } from '@assets/model/Store';

const braileSpacing = '⠀  ';
const SEPERATOR = '::';

export type IndustryTag = {
    value: string;
};

interface IndustryTagSelectProps {
    tagStore: TaggingStore;
    allowSelectAll?: boolean;
}

export class TaggingStore {
    @observable accessor taggedIds: IndustryTag[] = [];
}

export const SPECIAL_INDUSTRY_TAG_ALL = 'ALL';
export const IndustryTagSelect = observer((props: IndustryTagSelectProps) => {
    const allowSelectAll = props.allowSelectAll ?? false;

    function groupBy(list, keyGetter) {
        const map = {};
        list.forEach(item => {
            const key = keyGetter(item);
            if (!map.hasOwnProperty(key)) {
                map[key] = [];
            }
            map[key].push(item);
        });

        return map;
    }
    const { tagStore } = props;

    const updateSelectionIndustry = (selected: []) => {
        var updated = [];

        selected.forEach((selection: any) => {
            if (!updated.find((item: any) => item.value == selection.value)) {
                updated.push({
                    value: selection.value
                });
            }
        });
        //setMultiSelectionsIndustry(updated);

        tagStore.taggedIds = updated;
    };

    function filterBy(option, ticker) {
        return (
            option.value.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1
        );
    }

    var typeahead_props = {};
    typeahead_props['renderMenu'] = (
        results,
        {
            newSelectionPrefix,
            paginationText,
            renderMenuItemChildren,
            ...menuProps
        },
        state
    ) => {
        let index = 0;
        const list = groupBy(results, a => a.industry);
        const items = Object.keys(list)
            .sort()
            .map(region => {
                var subitems = list[region];
                var header = <Menu.Header>{region}</Menu.Header>;
                if (subitems[0].value == region) {
                    //kind of hackish
                    header = null;
                }

                return (
                    <Fragment key={region}>
                        {index !== 0 && <Menu.Divider />}
                        {header}
                        {subitems.map(i => {
                            var isSelected = tagStore.taggedIds.find(
                                a => a.value == i.value
                            );
                            var cls = classNames({
                                [style.selected]: isSelected
                            });
                            const braileCount =
                                (i.value as string).split(SEPERATOR).length - 1;
                            const braile = braileSpacing.repeat(braileCount);
                            const label = `${braile}${i.label}`;
                            const item = (
                                //<a aria-label="Consumer/Retail" aria-selected="false" id="industry-search-item-0" role="option" class="dropdown-item" href="#">Consumer/Retail</a>
                                <MenuItem
                                    key={index}
                                    option={i}
                                    position={index}
                                    className={cls}
                                >
                                    <Highlighter search={state.text}>
                                        {label}
                                    </Highlighter>
                                </MenuItem>
                            );

                            index += 1;
                            return item;
                        })}
                    </Fragment>
                );
            });

        return <Menu {...menuProps}>{items}</Menu>;
    };

    interface TagOption {
        label: string;
        value: string;
        industry: string;
    }

    var options: TagOption[] = [];

    if (allowSelectAll) {
        options.push({
            label: SPECIAL_INDUSTRY_TAG_ALL,
            value: SPECIAL_INDUSTRY_TAG_ALL,
            industry: SPECIAL_INDUSTRY_TAG_ALL
        });
    }

    const industry = useClientSettingStore().industryTypes;
    industry.forEach(industry => {
        var name = industry.name;
        options.push({
            label: name,
            value: name,
            industry: name
        });
        industry.subtypes.forEach(sub_industry => {
            options.push({
                label: sub_industry.name,
                value: `${name}${SEPERATOR}${sub_industry.name}`,
                industry: name
            });
        });
    });

    const selected = tagStore.taggedIds.map((item: any) => {
        const parts = item.value.split(SEPERATOR);
        const label = parts[parts.length - 1];
        return {
            label: label,
            value: item.value,
            industry: parts[0]
        };
    });

    return (
        <Typeahead
            {...typeahead_props}
            id="industry-search"
            className={style.industrySearch}
            filterBy={filterBy}
            options={options}
            placeholder="Filter by Industry"
            onChange={updateSelectionIndustry}
            selected={selected}
            multiple={true}
        ></Typeahead>
    );
});
